module.exports = __webpack_public_path__ + "media/images/hourglass-2f31e1fd88cedd4777c8590dc42559ba.svg";